import { Injectable, PLATFORM_ID, inject, DOCUMENT } from '@angular/core';

import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class StructureDataService {
    private document = inject<Document>(DOCUMENT);
    private platformId = inject<Object>(PLATFORM_ID);

    addStructuredData(jsonLd: object) {
        if (isPlatformBrowser(this.platformId)) {
            const script = this.document.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(jsonLd);
            this.document.head.appendChild(script);
        }
    }
}
